import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

interface Response {
    product_idx: number;
    product_name: string;
    product_amount: number;
    product_category: {
        product_category_idx: number;
        category_name: string;
        category_image: string;
        wreath_option: boolean;
        union_option: boolean;
    };
    product_image: {
        file_idx: number;
        file_name: string;
        original_name: string;
    };
}

export const useGetProduct = (
    customer_idx: number,
    product_category_idx?: number,
    searchtxt?: string,
): UseQueryResult<Response[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    let url = enum_api_uri.user.get_product.replace(":customer_idx", customer_idx.toString());

    const params = []; // 쿼리 매개변수를 저장할 배열

    if (product_category_idx) {
        params.push(`product_category_idx=${product_category_idx}`);
    }
    if (searchtxt) {
        params.push(`search=product_name&searchtxt=${searchtxt}`);
    }

    // 쿼리 매개변수가 있는 경우 URL에 추가
    if (params.length > 0) {
        url += `?${params.join("&")}`;
    }

    return useQuery<Response[], Error>({
        queryKey: ["getUserProduct", customer_idx, product_category_idx, searchtxt],
        queryFn: async () => {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: !!customer_idx,
        // placeholderData: prevData => {
        //     if (prevData) {
        //         return {
        //             ...prevData,
        //         };
        //     }
        //     return undefined;
        // },
    });
};
